( function( $, document, window ) {
    'use strict';

    $( function() {
    	const $header = $( '.js-site-header' );
        const $secondary = $( '.js-site-header-secondary' );
        const stickyClass = 'is-sticky';
        const visibleClass = 'is-active';
	    const interval = 250;
	    const distance = 1000;
	    let didScroll = false;
	    let lastScrollTop = 0;

        $( window ).on( 'scroll', function() {
        	didScroll = true;
        } );

        setInterval( () => {
        	if ( didScroll ) {
        		hasScrolled();
        		didScroll = false;
	        }
        }, interval );

        const displayHeader = () => {
	        let currentScrollTop = $( window ).scrollTop() || $( 'body' ).scrollTop();

	        if ( currentScrollTop > distance ) {
	        	$header.addClass( stickyClass ).addClass( visibleClass );
	        } else {
		        if ( $header.hasClass( stickyClass ) ) {
			        $header.removeClass( visibleClass );
			        setTimeout( () => {
				        $header.removeClass( stickyClass );
			        }, interval );
		        }
	        }

	        if ( currentScrollTop < ( $header.outerHeight() ) ) {
		        // $header.removeClass( stickyClass );
	        }
	    };

	    const hasScrolled = () => {
		    displayHeader();
	    };

    } );
} )( jQuery, document, window );
